import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
export const getDashboardDataServiceShopTypeDistribution = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/ServiceShopTypeDistribution');
    return response.data;
  });
export const getDashboardDataServiceShopTechnicianDistribution = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/ServiceShopTechnicianDistribution');
    return response.data;
  });
export const getDashboardDataWorkCaseStatusDistribution = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/WorkCaseStatusDistribution');
    return response.data;
  });
export const getDashboardDataWarrantyTypeDistribution = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/WarrantyTypeDistribution');
    return response.data;
  });
export const getDashboardDataUnitCosts = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/UnitCosts');
    return response.data;
  });
export const getDashboardDataRepairRates = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/RepairRates');
    return response.data;
  });
export const getDashboardDataAverageRepairTime = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/AverageRepairTime');
    return response.data;
  });
export const getDashboardDataRepairPeriodDistribution = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/RepairPeriodDistribution');
    return response.data;
  });
export const getDashboardDataSiriusRoleTypes = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/SiriusRoleTypes');
    return response.data;
  });
export const getDashboardDataReturnReasonDistribution = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/ReturnReasonDistribution');
    return response.data;
  });
export const getDashboardDataFeedbackStatusDistribution = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/FeedbackStatusDistribution');
    return response.data;
  });
export const getDashboardDataAVGAppointmentCompliance = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/AVGAppointmentCompliance');
    return response.data;
  });
  export const getDashboardDataTotalCompletedRepairs = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/TotalCompletedRepairs');
    return response.data;
  });
export const getDashboardDataAppointmentCompliance = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/AppointmentCompliance');
    return response.data;
  });
export const getDashboardDataPartsFittedRatio = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/PartsFittedRatio');
    return response.data;
  });
export const getDashboardDataRepeatedRepair = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/RepeatedRepair');
    return response.data;
  });
  export const getDashboardDataFLSRatio = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/FLSRatio');
    return response.data;
  });
export const getDashboardDataAcceptedReturnsRate = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/AcceptedReturnsRate');
    return response.data;
  });
export const getDashboardDataServiceShopCount = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/ServiceShopCounts');
    return response.data;
  });
export const getDashboardDataTotalRepair = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/TotalRepairCount');
    return response.data;
  });
export const getDashboardDataRepeatedRepairLast12Month = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/MultiUsedProduct');
    return response.data;
  });
export const getDashboardDataNPSScore = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/NPSScore');
    return response.data;
  });
export const getDashboardDataAverageRepairRate = createAsyncThunk('/getDashboardData', async (data) => {
    const response = await axios.get('/GetDashboardData/' + data + '/0/0/AverageRepairRate');
    return response.data;
  });
  const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
      loading: '',
      dashboardData: [],
      ServiceShopTypeDistributionData: [],
      ServiceShopTechnicianDistributionData: [],
      WorkCaseStatusDistributionData: [],
      WarrantyTypeDistributionData: [],
      UnitCostsData: [],
      RepairRatesData: [],
      AverageRepairTimeData: [],
      AVGAppointmentComplianceData: [],
      SiriusRoleTypesData: [],
      ReturnReasonDistributionData: [],
      FeedbackStatusDistributionData: [],
      RepairPeriodDistributionData: [],
      TotalCompletedRepairsData: [],
      AppointmentComplianceData: [],
      PartsFittedRatioData: [],
      RepeatedRepairData: [],
      FLSRatioData: [],
      AcceptedReturnsRateData: [],
      ServiceShopCountData: [],
      TotalRepairData: [],
      RepeatedRepairLast12MonthData: [],
      NPSScoreData: [],
      AverageRepairRateData: [],
      error: '',
    },
    reducers: {  
      refreshData(state) {
        state.dashboardData = []
      },
    },
    extraReducers: {
      [getDashboardDataServiceShopTypeDistribution.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataServiceShopTypeDistribution.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataServiceShopTypeDistribution.fulfilled]: (state, action) => {
        state.ServiceShopTypeDistributionData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataServiceShopTechnicianDistribution.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataServiceShopTechnicianDistribution.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataServiceShopTechnicianDistribution.fulfilled]: (state, action) => {
        state.ServiceShopTechnicianDistributionData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataWorkCaseStatusDistribution.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataWorkCaseStatusDistribution.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataWorkCaseStatusDistribution.fulfilled]: (state, action) => {
        state.WorkCaseStatusDistributionData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataWarrantyTypeDistribution.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataWarrantyTypeDistribution.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataWarrantyTypeDistribution.fulfilled]: (state, action) => {
        state.WarrantyTypeDistributionData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataUnitCosts.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataUnitCosts.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataUnitCosts.fulfilled]: (state, action) => {
        state.UnitCostsData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataSiriusRoleTypes.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataSiriusRoleTypes.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataSiriusRoleTypes.fulfilled]: (state, action) => {
        state.SiriusRoleTypesData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataReturnReasonDistribution.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataReturnReasonDistribution.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataReturnReasonDistribution.fulfilled]: (state, action) => {
        state.ReturnReasonDistributionData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataFeedbackStatusDistribution.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataFeedbackStatusDistribution.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataFeedbackStatusDistribution.fulfilled]: (state, action) => {
        state.FeedbackStatusDistributionData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataRepairPeriodDistribution.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataRepairPeriodDistribution.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataRepairPeriodDistribution.fulfilled]: (state, action) => {
        state.RepairPeriodDistributionData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataRepairRates.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataRepairRates.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataRepairRates.fulfilled]: (state, action) => {
        state.RepairRatesData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataAverageRepairTime.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataAverageRepairTime.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataAverageRepairTime.fulfilled]: (state, action) => {
        state.AverageRepairTimeData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataAVGAppointmentCompliance.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataAVGAppointmentCompliance.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataAVGAppointmentCompliance.fulfilled]: (state, action) => {
        state.AVGAppointmentComplianceData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataTotalCompletedRepairs.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataTotalCompletedRepairs.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataTotalCompletedRepairs.fulfilled]: (state, action) => {
        state.TotalCompletedRepairsData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataAppointmentCompliance.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataAppointmentCompliance.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataAppointmentCompliance.fulfilled]: (state, action) => {
        state.AppointmentComplianceData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataPartsFittedRatio.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataPartsFittedRatio.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataPartsFittedRatio.fulfilled]: (state, action) => {
        state.PartsFittedRatioData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataRepeatedRepair.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataRepeatedRepair.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataRepeatedRepair.fulfilled]: (state, action) => {
        state.RepeatedRepairData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataFLSRatio.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataFLSRatio.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataFLSRatio.fulfilled]: (state, action) => {
        state.FLSRatioData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataAcceptedReturnsRate.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataAcceptedReturnsRate.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataAcceptedReturnsRate.fulfilled]: (state, action) => {
        state.AcceptedReturnsRateData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataServiceShopCount.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataServiceShopCount.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataServiceShopCount.fulfilled]: (state, action) => {
        state.ServiceShopCountData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataTotalRepair.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataTotalRepair.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataTotalRepair.fulfilled]: (state, action) => {
        state.TotalRepairData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataRepeatedRepairLast12Month.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataRepeatedRepairLast12Month.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataRepeatedRepairLast12Month.fulfilled]: (state, action) => {
        state.RepeatedRepairLast12MonthData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataNPSScore.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataNPSScore.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataNPSScore.fulfilled]: (state, action) => {
        state.NPSScoreData = action.payload;
        state.loading = 'Finished';
      },
      [getDashboardDataAverageRepairRate.pending]: (state) => {
        state.loading = 'Loading';
      },
      [getDashboardDataAverageRepairRate.rejected]: (state, action) => {
        state.error = action.payload;
      },
      [getDashboardDataAverageRepairRate.fulfilled]: (state, action) => {
        state.AverageRepairRateData = action.payload;
        state.loading = 'Finished';
      },
    }
});
export const dashboardActions = dashboardSlice.actions;

export default dashboardSlice;
